import ActionCableConsumer from '../channels/consumer.js'

// KastioActionCable is a wrapper over the Actioncable API
// The plan is to extend the API, and make it more compatible with
// the existing code

function createSubscription (args) {
  const connectionParams = {
    channel: args.channel,
    event_slug: args.event_slug
  }

  if (args.uuid) {
    connectionParams.uuid = args.uuid
  }

  const callbacks = {
    connected() {
      console.log("Connected to ", args.channel);
      if (args.connected) args.connected()
    },

    disconnected() {
      if (args.disconnected) args.disconnected()
    },

    received(data) {
      if (args.received) args.received(data)
    }
  }

  return ActionCableConsumer.subscriptions.create(connectionParams, callbacks);
}

function subscribe (args) {
  return createSubscription(args)
}

function unsubscribe (args) {
  // TODO
}

const KastioActionCable = {
  subscribe: subscribe,
  unsubscribe: unsubscribe,
  cable: ActionCableConsumer
}

export default KastioActionCable
